import React from "react";

import {useABTest} from "../hooks/use_ab_test";

export interface IProps {
    children: (() => React.ReactNode)[];
    disableEventPush?: boolean;
    pushEventOnlyOnce?: true;
    id: string;
    variants: number;
    withSSR?: boolean;
}

export const ABTestContainer = (props: IProps) => {
    const {canABTestBeRendered, abTestVariant} = useABTest(props);

    if (!canABTestBeRendered) {
        return null;
    }

    if (typeof abTestVariant === "number" && Number.isFinite(abTestVariant) && props.children.length) {
        return <>{props.children[abTestVariant > props.variants || abTestVariant < 0 ? 0 : abTestVariant]()}</>;
    }

    if (!abTestVariant && props.children.length) {
        if (process.env.NODE_ENV === "development" && !process.env.IS_TESTING) {
            throw new Error(`AB test for id ${props.id} not initialized correctly. Check configuration (especially "expires" and "path" fields).`);
        }
        // TODO: Add bugsnag notification after CU-238dxf2 will be completed.
        return <>{props.children[0]()}</>;
    }

    return null;
};
import React from "react";

import {useABTest} from "../hooks/use_ab_test";

export interface IProps {
    children: (() => React.ReactNode)[];
    disableEventPush?: boolean;
    pushEventOnlyOnce?: true;
    id: string;
    variants: number;
    withSSR?: boolean;
}

export const ABTestContainer = (props: IProps) => {
    const {canABTestBeRendered, abTestVariant} = useABTest(props);

    if (!canABTestBeRendered) {
        return null;
    }

    if (typeof abTestVariant === "number" && Number.isFinite(abTestVariant) && props.children.length) {
        return <>{props.children[abTestVariant > props.variants || abTestVariant < 0 ? 0 : abTestVariant]()}</>;
    }

    if (!abTestVariant && props.children.length) {
        if (process.env.NODE_ENV === "development" && !process.env.IS_TESTING) {
            throw new Error(`AB test for id ${props.id} not initialized correctly. Check configuration (especially "expires" and "path" fields).`);
        }
        // TODO: Add bugsnag notification after CU-238dxf2 will be completed.
        return <>{props.children[0]()}</>;
    }

    return null;
};
